// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDX2_YJ3PDkRXfIO7qEAxa_8bYK3e4vWhM',
  authDomain: 'mykinship-d546a.firebaseapp.com',
  projectId: 'mykinship-d546a',
  storageBucket: 'mykinship-d546a.firebasestorage.app',
  messagingSenderId: '1046246272136',
  appId: '1:1046246272136:web:09913ac5cba6289945c33d',
  measurementId: 'G-34D90Q2XYC'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export async function unregisterFirebaseMessagingSW() {
  if (!('serviceWorker' in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();

  for (const reg of registrations) {
    // Only unregister firebase-messaging-sw.js
    if (reg.active?.scriptURL.includes('firebase-messaging-sw.js')) {
      await reg.unregister();
    }
  }
}

export const generateToken = async (): Promise<string | null> => {
  const permission = await Notification.requestPermission();

  if (permission === 'granted') {
    try {
      // Only register the service worker if not already registered
      let registration = await navigator.serviceWorker.getRegistration(
        '/firebase-messaging-sw.js'
      );
      if (!registration) {
        registration = await navigator.serviceWorker.register(
          '/firebase-messaging-sw.js'
        );
      }

      // Pass the registration into getToken
      const token = await getToken(messaging, {
        vapidKey:
          'BDJSSqkIRSwLyroHpP8OZijjKJ5-aP26InSV71yJwWUMs24y2sdeDcyhLVcXy5co3f6HNpTlbfBz5pfQHcuxLLQ',
        serviceWorkerRegistration: registration
      });

      if (token) {
        return token;
      } else {
        console.warn('❌ No registration token available.');
        return null;
      }
    } catch (err) {
      console.error('❌ An error occurred while retrieving token:', err);
      return null;
    }
  } else if (permission === 'denied') {
    console.error('❌ Notification permission DENIED by user');
    return null;
  } else {
    console.warn('⚠️ Notification permission dismissed (default state)');
    return null;
  }
};
